(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-related"] && !Shopify.designMode) return;
  try {
    
  class RelatedArticles extends HTMLElement {
    constructor() {
      super();

      this.swiperElement = this.querySelector('[data-swiper-related-articles]');

      this.swiperOptions = {
        loop: false,
        autoplay: false,
        slidesPerView: 4,
        direction: 'horizontal',
      };

      // Check if we have extra options on the HTML
      if (this && this.dataset && this.dataset.options) {
        const jsonOptions = JSON.parse(this.dataset.options);

        if (jsonOptions) {
          this.swiperOptions = {
            ...this.swiperOptions,
            ...jsonOptions,
          };
        }
      }

      this.init();
    }

    init() {
      window.addEventListener('load', (event) => {
        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
      });
    }
  }

  customElements.define('related-articles-swiper', RelatedArticles);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  customElements.define('cart-note', CartNote);

  /* 4.4.12 "Move to wishlist": save the product in the theme wishlist (assets/jl-lists.js), then remove the line
     the way the Remove link does (cart.js). Delegated, because cart.js replaces the lines after every change. */
  document.addEventListener('click', (event) => {
    const btn = event.target.closest && event.target.closest('[data-jl-cart-move]');
    if (!btn) return;
    event.preventDefault();
    const items = btn.closest('cart-items');
    if (!items || btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    try {
      if (window.JLWishlist && !window.JLWishlist.has(btn.dataset.handle)) {
        window.JLWishlist.add(btn.dataset.handle, { source: 'cart_move', productId: btn.dataset.productId, itemName: btn.dataset.itemName || '' });
      }
    } catch (e) { /* storage blocked: the line is still removed */ }
    items.updateQuantity(btn.dataset.index, 0);
  });

  } catch(e) { console.error(e); }
})();
})();
